import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Navigate, useLocation } from "react-router-dom"
import { setRedirectionUrl } from "store/slices/userSlice"

const AuthMiddleware = (props) => {
  const { user, auth, userType, isSelfLogout, redirectionUrl, oldUserType } =
    useSelector((state) => state.user)
  const dispatch = useDispatch()
  const path = useLocation()

  useEffect(() => {
    if (!auth && isSelfLogout) {
      let url = `${path.pathname}${path.search ?? ""}`
      dispatch(setRedirectionUrl({ url }))
    }

    if (auth && redirectionUrl) {
      dispatch(setRedirectionUrl({ url: "" }))
    }
  }, [auth, isSelfLogout])

  if (!auth) {
    return (
      <Navigate
        to={{
          pathname:
            userType && userType === "ADMIN" ? "/admin/login" : "/login",
          state: { from: props.location },
        }}
      />
    )
  }
  if (auth && redirectionUrl && userType === oldUserType)
    return <Navigate to={redirectionUrl} />

  return <React.Fragment>{props.children}</React.Fragment>
}

export default AuthMiddleware
